import React, { useEffect, useState } from "react";
import YearCalendar from "../Components/Holdiays/HolidaysCalendar";
import { useAppDispatch } from "../_App/Redux/hooks";
import { findPublicHolidayOrWeekend } from "../_App/Redux/Slices/holidays/holidaysSlice";

const HolidaysPage = () => {
  const dispatch = useAppDispatch();
  const [refresh, setRefresh] = useState(true);
  useEffect(() => {
    dispatch(findPublicHolidayOrWeekend("Tous"));
  }, [dispatch, refresh]);
  return <YearCalendar refresh={refresh} setRefresh={setRefresh} />;
};

export default HolidaysPage;
